(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("JPDcF", function(module, exports) {
parcelRequire("71uYQ");
parcelRequire("kVIKx");
parcelRequire("lzblW");
parcelRequire("hlTU3");
parcelRequire("3p8Kp");
parcelRequire("kS1yz");
parcelRequire("dryUY");

});
parcelRequire.register("71uYQ", function(module, exports) {
parcelRequire("kN2au");
parcelRequire("iDFEI");
parcelRequire("6g0ya");
parcelRequire("iT7pl");

});
parcelRequire.register("kN2au", function(module, exports) {
var $f22a10cefcbbd4c3$var$initGallery = function(gallerySelector, galleryLinkSelector, postfix) {
    if (postfix === void 0) postfix = "I";
    var galleries = document.querySelectorAll(gallerySelector);
    var galleryId = "gallery-".concat(postfix);
    galleries.forEach(function(gallery) {
        var links = gallery.querySelectorAll(galleryLinkSelector);
        links.forEach(function(link) {
            link.setAttribute("data-fancybox", galleryId);
        });
        galleryId += postfix;
    });
};
$f22a10cefcbbd4c3$var$initGallery(".gallery", ".gallery-icon a");
$f22a10cefcbbd4c3$var$initGallery(".wp-block-gallery", ".blocks-gallery-item a", "W");

});

parcelRequire.register("iDFEI", function(module, exports) {
(function() {
    //Functions
    function asideNavMobile() {
        const widgetCategoriesTitle = document.querySelectorAll(".widget_categories .widgettitle");
        if (widgetCategoriesTitle) for(let i = 0; i < widgetCategoriesTitle.length; i++){
            let category = widgetCategoriesTitle[i];
            category.addEventListener("click", function() {
                //Up to tablet portrait - up to 991px
                if (window.matchMedia("(max-width: 61.938em)").matches) {
                    category.classList.toggle("js-open");
                    if (category.parentNode.querySelector("ul")) category.parentNode.querySelector("ul").classList.toggle("js-open");
                    if (category.parentNode.querySelector("form")) category.parentNode.querySelector("form").classList.toggle("js-open");
                }
            });
        }
        const widgetNavmMenu = document.querySelectorAll(".widget_nav_menu .widgettitle");
        if (widgetNavmMenu) for(let i = 0; i < widgetNavmMenu.length; i++){
            let navMenu = widgetNavmMenu[i];
            navMenu.addEventListener("click", function() {
                //Up to tablet portrait - up to 991px
                if (window.matchMedia("(max-width: 61.938em)").matches) {
                    navMenu.classList.toggle("js-open");
                    navMenu.parentNode.querySelector("ul").classList.toggle("js-open");
                }
            });
        }
        const widgetPages = document.querySelectorAll(".widget_pages .widgettitle");
        if (widgetPages) for(let i = 0; i < widgetPages.length; i++){
            let page = widgetPages[i];
            page.addEventListener("click", function() {
                //Up to tablet portrait - up to 991px
                if (window.matchMedia("(max-width: 61.938em)").matches) {
                    page.classList.toggle("js-open");
                    page.parentNode.querySelector("ul").classList.toggle("js-open");
                }
            });
        }
    }
    function asideNavResizeReset() {
        const widgetCategoriesTitle = document.querySelectorAll(".widget_categories .widgettitle");
        if (widgetCategoriesTitle) for(let i = 0; i < widgetCategoriesTitle.length; i++){
            let category = widgetCategoriesTitle[i];
            if (category.classList.contains("js-open")) category.classList.remove("js-open");
            if (category.parentNode.querySelector("ul") && category.parentNode.querySelector("ul").classList.contains("js-open")) category.parentNode.querySelector("ul").classList.remove("js-open");
            if (category.parentNode.querySelector("form")) {
                if (category.parentNode.querySelector("form").classList.contains("js-open")) category.parentNode.querySelector("form").classList.remove("js-open");
            }
        }
        const widgetNavmMenu = document.querySelectorAll(".widget_nav_menu .widgettitle");
        if (widgetNavmMenu) for(let i = 0; i < widgetNavmMenu.length; i++){
            let navMenu = widgetNavmMenu[i];
            if (navMenu.classList.contains("js-open")) navMenu.classList.remove("js-open");
            if (navMenu.parentNode.querySelector("ul") && navMenu.parentNode.querySelector("ul").classList.contains("js-open")) navMenu.parentNode.querySelector("ul").classList.remove("js-open");
        }
        const widgetPages = document.querySelectorAll(".widget_pages .widgettitle");
        if (widgetPages) for(let i = 0; i < widgetPages.length; i++){
            let page = widgetPages[i];
            if (page.classList.contains("js-open")) page.classList.remove("js-open");
            if (page.parentNode.querySelector("ul") && page.parentNode.querySelector("ul").classList.contains("js-open")) page.parentNode.querySelector("ul").classList.remove("js-open");
        }
    }
    asideNavMobile();
    //Resize
    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 62em)").matches) asideNavResizeReset();
    });
})();

});

parcelRequire.register("6g0ya", function(module, exports) {
parcelRequire("7oN3a");
parcelRequire("8TwYC");
parcelRequire("kNzkh");

});
parcelRequire.register("7oN3a", function(module, exports) {
// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:
//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
// Converts to:
//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
var $5630d2a021cd5f07$var$links = document.querySelectorAll(".entry-content a:not(.entry-content .i-gallery__icon a)");
$5630d2a021cd5f07$var$links.forEach(function(link) {
    var image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img');
    if (image !== null) {
        link.setAttribute("data-fancybox", "");
        if (image.classList.contains("aligncenter")) {
            image.classList.remove("aligncenter");
            link.classList.add("aligncenter");
        }
    }
});

});

parcelRequire.register("8TwYC", function(module, exports) {
var $679d0a49f8589b30$var$iframes = document.querySelectorAll(".entry-content iframe");
$679d0a49f8589b30$var$iframes.forEach(function(iframe) {
    var _a;
    var iframeSrc = iframe.getAttribute("src");
    if (iframeSrc === null) return;
    if (iframeSrc.indexOf("youtube") !== -1) {
        iframe.classList.add("embed-responsive-item");
        iframe.removeAttribute("height");
        iframe.removeAttribute("width");
        var iframeWrap = document.createElement("div");
        iframeWrap.classList.add("ratio", "ratio-16x9");
        (_a = iframe.parentNode) === null || _a === void 0 || _a.insertBefore(iframeWrap, iframe);
        iframeWrap.appendChild(iframe);
    }
});

});

parcelRequire.register("kNzkh", function(module, exports) {
var $f243c94214d844ef$var$removeWidthHeight = function(selector) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
        element.removeAttribute("width");
        element.removeAttribute("height");
        element === null || element === void 0 || element.style.setProperty("width", null);
        element === null || element === void 0 || element.style.setProperty("height", null);
    });
};
$f243c94214d844ef$var$removeWidthHeight(".entry-content table");
$f243c94214d844ef$var$removeWidthHeight(".entry-content tr");
$f243c94214d844ef$var$removeWidthHeight(".entry-content th");
$f243c94214d844ef$var$removeWidthHeight(".entry-content td");

});


parcelRequire.register("iT7pl", function(module, exports) {
// Added submenu button, in order to dropdown submenu
// Style sub-menu__button element to your needs
var $dc031c1106284b94$var$mobileQuery = window.matchMedia("(max-width: 61.999em)");
var $dc031c1106284b94$var$itemsWithSubmenu = document.querySelectorAll(".menu-item-has-children");
$dc031c1106284b94$var$itemsWithSubmenu.forEach(function(item) {
    item.insertAdjacentHTML("beforeend", '<span class="sub-menu__button"></span>');
    var submenuButton = item.querySelector(".sub-menu__button");
    var submenu = item.querySelector(":scope > .sub-menu");
    var handleSubmenu = function(event) {
        if (!$dc031c1106284b94$var$mobileQuery.matches) return;
        event.preventDefault();
        submenu === null || submenu === void 0 || submenu.classList.toggle("--active");
        submenuButton === null || submenuButton === void 0 || submenuButton.classList.toggle("--active");
    };
    submenuButton === null || submenuButton === void 0 || submenuButton.addEventListener("click", handleSubmenu);
});

});


parcelRequire.register("kVIKx", function(module, exports) {

var $6wTyf = parcelRequire("6wTyf");
const $f3cbd7deab680c89$var$mainHeader = document.querySelector(".main-header");
if ($f3cbd7deab680c89$var$mainHeader !== null) {
    const headRoomHeaderOptions = {
        offset: $f3cbd7deab680c89$var$mainHeader.clientHeight
    };
    const headRoomHeader = new (0, (/*@__PURE__*/$parcel$interopDefault($6wTyf)))($f3cbd7deab680c89$var$mainHeader, headRoomHeaderOptions);
    headRoomHeader.init();
    const mainContent = document.querySelector("main");
    const resizeObserver = new ResizeObserver(()=>{
        mainContent.style.paddingTop = `${$f3cbd7deab680c89$var$mainHeader.clientHeight}px`;
    });
    resizeObserver.observe($f3cbd7deab680c89$var$mainHeader);
}

});
parcelRequire.register("6wTyf", function(module, exports) {
/*!
 * headroom.js v0.12.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2020 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function isBrowser() {
        return typeof window !== "undefined";
    }
    /**
   * Used to detect browser support for adding an event listener with options
   * Credit: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
   */ function passiveEventsSupported() {
        var supported = false;
        try {
            var options = {
                // eslint-disable-next-line getter-return
                get passive () {
                    supported = true;
                }
            };
            window.addEventListener("test", options, options);
            window.removeEventListener("test", options, options);
        } catch (err) {
            supported = false;
        }
        return supported;
    }
    function isSupported() {
        return !!(isBrowser() && (function() {}).bind && "classList" in document.documentElement && Object.assign && Object.keys && requestAnimationFrame);
    }
    function isDocument(obj) {
        return obj.nodeType === 9; // Node.DOCUMENT_NODE === 9
    }
    function isWindow(obj) {
        // `obj === window` or `obj instanceof Window` is not sufficient,
        // as the obj may be the window of an iframe.
        return obj && obj.document && isDocument(obj.document);
    }
    function windowScroller(win) {
        var doc = win.document;
        var body = doc.body;
        var html = doc.documentElement;
        return {
            /**
       * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
       * @return {Number} the scroll height of the document in pixels
       */ scrollHeight: function() {
                return Math.max(body.scrollHeight, html.scrollHeight, body.offsetHeight, html.offsetHeight, body.clientHeight, html.clientHeight);
            },
            /**
       * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
       * @return {Number} the height of the viewport in pixels
       */ height: function() {
                return win.innerHeight || html.clientHeight || body.clientHeight;
            },
            /**
       * Gets the Y scroll position
       * @return {Number} pixels the page has scrolled along the Y-axis
       */ scrollY: function() {
                if (win.pageYOffset !== undefined) return win.pageYOffset;
                return (html || body.parentNode || body).scrollTop;
            }
        };
    }
    function elementScroller(element) {
        return {
            /**
       * @return {Number} the scroll height of the element in pixels
       */ scrollHeight: function() {
                return Math.max(element.scrollHeight, element.offsetHeight, element.clientHeight);
            },
            /**
       * @return {Number} the height of the element in pixels
       */ height: function() {
                return Math.max(element.offsetHeight, element.clientHeight);
            },
            /**
       * Gets the Y scroll position
       * @return {Number} pixels the element has scrolled along the Y-axis
       */ scrollY: function() {
                return element.scrollTop;
            }
        };
    }
    function createScroller(element) {
        return isWindow(element) ? windowScroller(element) : elementScroller(element);
    }
    /**
   * @param element EventTarget
   */ function trackScroll(element, options, callback) {
        var isPassiveSupported = passiveEventsSupported();
        var rafId;
        var scrolled = false;
        var scroller = createScroller(element);
        var lastScrollY = scroller.scrollY();
        var details = {};
        function update() {
            var scrollY = Math.round(scroller.scrollY());
            var height = scroller.height();
            var scrollHeight = scroller.scrollHeight();
            // reuse object for less memory churn
            details.scrollY = scrollY;
            details.lastScrollY = lastScrollY;
            details.direction = scrollY > lastScrollY ? "down" : "up";
            details.distance = Math.abs(scrollY - lastScrollY);
            details.isOutOfBounds = scrollY < 0 || scrollY + height > scrollHeight;
            details.top = scrollY <= options.offset[details.direction];
            details.bottom = scrollY + height >= scrollHeight;
            details.toleranceExceeded = details.distance > options.tolerance[details.direction];
            callback(details);
            lastScrollY = scrollY;
            scrolled = false;
        }
        function handleScroll() {
            if (!scrolled) {
                scrolled = true;
                rafId = requestAnimationFrame(update);
            }
        }
        var eventOptions = isPassiveSupported ? {
            passive: true,
            capture: false
        } : false;
        element.addEventListener("scroll", handleScroll, eventOptions);
        update();
        return {
            destroy: function() {
                cancelAnimationFrame(rafId);
                element.removeEventListener("scroll", handleScroll, eventOptions);
            }
        };
    }
    function normalizeUpDown(t) {
        return t === Object(t) ? t : {
            down: t,
            up: t
        };
    }
    /**
   * UI enhancement for fixed headers.
   * Hides header when scrolling down
   * Shows header when scrolling up
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */ function Headroom(elem, options) {
        options = options || {};
        Object.assign(this, Headroom.options, options);
        this.classes = Object.assign({}, Headroom.options.classes, options.classes);
        this.elem = elem;
        this.tolerance = normalizeUpDown(this.tolerance);
        this.offset = normalizeUpDown(this.offset);
        this.initialised = false;
        this.frozen = false;
    }
    Headroom.prototype = {
        constructor: Headroom,
        /**
     * Start listening to scrolling
     * @public
     */ init: function() {
            if (Headroom.cutsTheMustard && !this.initialised) {
                this.addClass("initial");
                this.initialised = true;
                // defer event registration to handle browser
                // potentially restoring previous scroll position
                setTimeout(function(self) {
                    self.scrollTracker = trackScroll(self.scroller, {
                        offset: self.offset,
                        tolerance: self.tolerance
                    }, self.update.bind(self));
                }, 100, this);
            }
            return this;
        },
        /**
     * Destroy the widget, clearing up after itself
     * @public
     */ destroy: function() {
            this.initialised = false;
            Object.keys(this.classes).forEach(this.removeClass, this);
            this.scrollTracker.destroy();
        },
        /**
     * Unpin the element
     * @public
     */ unpin: function() {
            if (this.hasClass("pinned") || !this.hasClass("unpinned")) {
                this.addClass("unpinned");
                this.removeClass("pinned");
                if (this.onUnpin) this.onUnpin.call(this);
            }
        },
        /**
     * Pin the element
     * @public
     */ pin: function() {
            if (this.hasClass("unpinned")) {
                this.addClass("pinned");
                this.removeClass("unpinned");
                if (this.onPin) this.onPin.call(this);
            }
        },
        /**
     * Freezes the current state of the widget
     * @public
     */ freeze: function() {
            this.frozen = true;
            this.addClass("frozen");
        },
        /**
     * Re-enables the default behaviour of the widget
     * @public
     */ unfreeze: function() {
            this.frozen = false;
            this.removeClass("frozen");
        },
        top: function() {
            if (!this.hasClass("top")) {
                this.addClass("top");
                this.removeClass("notTop");
                if (this.onTop) this.onTop.call(this);
            }
        },
        notTop: function() {
            if (!this.hasClass("notTop")) {
                this.addClass("notTop");
                this.removeClass("top");
                if (this.onNotTop) this.onNotTop.call(this);
            }
        },
        bottom: function() {
            if (!this.hasClass("bottom")) {
                this.addClass("bottom");
                this.removeClass("notBottom");
                if (this.onBottom) this.onBottom.call(this);
            }
        },
        notBottom: function() {
            if (!this.hasClass("notBottom")) {
                this.addClass("notBottom");
                this.removeClass("bottom");
                if (this.onNotBottom) this.onNotBottom.call(this);
            }
        },
        shouldUnpin: function(details) {
            var scrollingDown = details.direction === "down";
            return scrollingDown && !details.top && details.toleranceExceeded;
        },
        shouldPin: function(details) {
            var scrollingUp = details.direction === "up";
            return scrollingUp && details.toleranceExceeded || details.top;
        },
        addClass: function(className) {
            this.elem.classList.add.apply(this.elem.classList, this.classes[className].split(" "));
        },
        removeClass: function(className) {
            this.elem.classList.remove.apply(this.elem.classList, this.classes[className].split(" "));
        },
        hasClass: function(className) {
            return this.classes[className].split(" ").every(function(cls) {
                return this.classList.contains(cls);
            }, this.elem);
        },
        update: function(details) {
            if (details.isOutOfBounds) // Ignore bouncy scrolling in OSX
            return;
            if (this.frozen === true) return;
            if (details.top) this.top();
            else this.notTop();
            if (details.bottom) this.bottom();
            else this.notBottom();
            if (this.shouldUnpin(details)) this.unpin();
            else if (this.shouldPin(details)) this.pin();
        }
    };
    /**
   * Default options
   * @type {Object}
   */ Headroom.options = {
        tolerance: {
            up: 0,
            down: 0
        },
        offset: 0,
        scroller: isBrowser() ? window : null,
        classes: {
            frozen: "headroom--frozen",
            pinned: "headroom--pinned",
            unpinned: "headroom--unpinned",
            top: "headroom--top",
            notTop: "headroom--not-top",
            bottom: "headroom--bottom",
            notBottom: "headroom--not-bottom",
            initial: "headroom"
        }
    };
    Headroom.cutsTheMustard = isSupported();
    return Headroom;
});

});


parcelRequire.register("lzblW", function(module, exports) {

var $5Tf5z = parcelRequire("5Tf5z");
var $fb35ac4911525476$var$_a;
(0, (/*@__PURE__*/$parcel$interopDefault($5Tf5z))).polyfill();
var $fb35ac4911525476$var$scrollUpElement = document.getElementById("scroll-up");
if ($fb35ac4911525476$var$scrollUpElement !== null) {
    var $fb35ac4911525476$var$offsetFromTop_1 = ($fb35ac4911525476$var$_a = $fb35ac4911525476$var$scrollUpElement.getAttribute("data-offset-from-top")) !== null && $fb35ac4911525476$var$_a !== void 0 ? $fb35ac4911525476$var$_a : 100; // if not set default is 100px
    var $fb35ac4911525476$var$isInLimit_1 = function() {
        return document.body.scrollTop > $fb35ac4911525476$var$offsetFromTop_1 || document.documentElement.scrollTop > $fb35ac4911525476$var$offsetFromTop_1;
    };
    var $fb35ac4911525476$var$scrollHandle = function() {
        $fb35ac4911525476$var$scrollUpElement.classList.toggle("--active", $fb35ac4911525476$var$isInLimit_1());
    };
    var $fb35ac4911525476$var$scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    window.onscroll = $fb35ac4911525476$var$scrollHandle;
    $fb35ac4911525476$var$scrollUpElement.addEventListener("click", $fb35ac4911525476$var$scrollTop);
}

});
parcelRequire.register("5Tf5z", function(module, exports) {
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    module.exports = {
        polyfill: polyfill
    };
})();

});


parcelRequire.register("hlTU3", function(module, exports) {
var $ca1fc30271ca302f$var$transitionLength = 300;
var $ca1fc30271ca302f$var$openModal = function(modal) {
    modal.classList.add("--open");
    modal.classList.remove("--hidden");
};
var $ca1fc30271ca302f$var$closeModal = function(modal) {
    modal.classList.remove("--open");
    setTimeout(function() {
        modal.classList.add("--hidden");
    }, $ca1fc30271ca302f$var$transitionLength);
};
var $ca1fc30271ca302f$var$initTriggers = function() {
    var triggers = document.querySelectorAll("[data-modal-target]");
    triggers.forEach(function(trigger) {
        var _a;
        var modalTarget = document.getElementById((_a = trigger.getAttribute("data-modal-target")) !== null && _a !== void 0 ? _a : "");
        if (modalTarget === null) return;
        trigger.addEventListener("click", function(event) {
            event.preventDefault();
            $ca1fc30271ca302f$var$openModal(modalTarget);
        });
    });
};
var $ca1fc30271ca302f$var$initModals = function() {
    var modals = document.querySelectorAll(".c-modal");
    modals.forEach(function(modal) {
        var closeButtons = document.querySelectorAll(".c-modal__close");
        modal.style.setProperty("--transtion-length", "".concat($ca1fc30271ca302f$var$transitionLength, "ms"));
        closeButtons.forEach(function(closeButton) {
            closeButton.addEventListener("click", function(event) {
                event.preventDefault();
                $ca1fc30271ca302f$var$closeModal(modal);
            });
        });
        modal.addEventListener("click", function(event) {
            if (modal == event.target) $ca1fc30271ca302f$var$closeModal(modal);
        });
    });
};
// In case needed reinitialize modals
// When something is re rendered
var $ca1fc30271ca302f$var$init = function() {
    $ca1fc30271ca302f$var$initTriggers();
    $ca1fc30271ca302f$var$initModals();
};
var $ca1fc30271ca302f$export$2e2bcd8739ae039 = $ca1fc30271ca302f$var$init;
$ca1fc30271ca302f$var$init();

});

parcelRequire.register("3p8Kp", function(module, exports) {
var $27aa7dfb9dbc39e3$var$toggles = document.querySelectorAll(".--js-toggle-class");
$27aa7dfb9dbc39e3$var$toggles.forEach(function(toggle) {
    var _a;
    var toggleClassTargetSelector = (_a = toggle.dataset.toggleClassTarget) !== null && _a !== void 0 ? _a : "";
    var onClickOutToggleClass = toggle.dataset.toggleClassClickout === "true";
    var onOnlyParentsToggleClass = toggle.dataset.toggleClassOnlyParent === "true";
    var toggleClassName = toggle.dataset.toggleClassName;
    if (!toggleClassName) return;
    var toggleClassTargets = Array.from(document.querySelectorAll(toggleClassTargetSelector)).filter(function(toggleClassTarget) {
        return onOnlyParentsToggleClass && toggleClassTarget.contains(toggle) || !onOnlyParentsToggleClass;
    });
    if (toggleClassTargets.length <= 0) return;
    toggle.addEventListener("click", function(event) {
        toggleClassOnTarget(event);
    });
    if (onClickOutToggleClass) document.addEventListener("click", function(event) {
        removeClassOnTarget(event);
    });
    var toggleClassOnTarget = function(event) {
        event === null || event === void 0 || event.preventDefault();
        toggleClassTargets === null || toggleClassTargets === void 0 || toggleClassTargets.forEach(function(toggleTarget) {
            return toggleTarget.classList.toggle(toggleClassName);
        });
    };
    var removeClassOnTarget = function(event) {
        var isEventTargetChildOfTarget;
        toggleClassTargets.forEach(function(toggleTarget) {
            if (toggleTarget.contains(event === null || event === void 0 ? void 0 : event.target) || toggle.contains(event === null || event === void 0 ? void 0 : event.target)) isEventTargetChildOfTarget = true;
        });
        if (isEventTargetChildOfTarget) return;
        toggleClassTargets === null || toggleClassTargets === void 0 || toggleClassTargets.forEach(function(target) {
            return target.classList.remove(toggleClassName);
        });
    };
});

});

parcelRequire.register("kS1yz", function(module, exports) {
var $f31a0ee3edea857c$var$fileInputFields = document.querySelectorAll(".f-file");
$f31a0ee3edea857c$var$fileInputFields.forEach(function(fileInputField) {
    var _a, _b;
    var messageElement = fileInputField.querySelectorAll(".f-file__message")[0];
    var removeElement = fileInputField.querySelectorAll(".f-file__remove")[0];
    var defaultMessage = (_a = messageElement.textContent) !== null && _a !== void 0 ? _a : "";
    var sizeError = fileInputField.parentElement.querySelector(".f-file__size-error");
    var input = fileInputField.querySelectorAll("input[type=file]")[0];
    (_b = input.form) === null || _b === void 0 || _b.addEventListener("submit", function() {
        if (!fileInputField.classList.contains("--visible")) input.disabled = true;
        else input.disabled = false;
    });
    var preventDefault = function(e) {
        if (fileInputField.classList.contains("--visible")) {
            e.preventDefault();
            fileInputField.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };
    var validFilesSize = function() {
        var _a, _b;
        var sizeLimit = 7000000;
        //const sizeForMessage = `${(sizeLimit / 1000000).toFixed(1)} MB`
        var totalSize = 0;
        for(var i = 0; i < input.files.length; i++)totalSize += input.files[i].size;
        if (sizeLimit < totalSize) {
            fileInputField.classList.add("--error");
            if (sizeError) sizeError.classList.remove("--hidden");
            (_a = input.form) === null || _a === void 0 || _a.addEventListener("submit", preventDefault);
        } else {
            fileInputField.classList.remove("--error");
            if (sizeError) sizeError.classList.add("--hidden");
            (_b = input.form) === null || _b === void 0 || _b.removeEventListener("submit", preventDefault);
        }
    };
    input.addEventListener("change", function() {
        if (!input.files) return;
        validFilesSize();
        var name = "";
        if (input.files.length > 1) name = "(".concat(input.files.length, "): ");
        for(var i = 0; i < input.files.length; i++){
            var fileName = input.files[i].name;
            var maxLength = 10;
            var extensionIndex = fileName.lastIndexOf(".");
            var extension = fileName.slice(extensionIndex - 1);
            var nameWithoutExtension = fileName.slice(0, extensionIndex - 1);
            if (nameWithoutExtension.length > maxLength) nameWithoutExtension = nameWithoutExtension.slice(0, maxLength) + "...";
            name = name.concat("".concat(nameWithoutExtension + extension, ", "));
        }
        changeInputValue(name);
    });
    removeElement === null || removeElement === void 0 || removeElement.addEventListener("click", function(event) {
        event.preventDefault();
        changeInputValue("");
        validFilesSize();
    });
    var changeInputValue = function(value) {
        var message = defaultMessage;
        if (value.length > 0) {
            message = value;
            removeElement === null || removeElement === void 0 || removeElement.classList.add("--visible");
        } else {
            input.value = "";
            removeElement === null || removeElement === void 0 || removeElement.classList.remove("--visible");
        }
        changeMessage(messageElement, message);
    };
    var changeMessage = function(messageElement, message) {
        messageElement.textContent = message.replace(/^.*[\\\/]/, ""); //eslint-disable-line no-useless-escape
    };
});

});

parcelRequire.register("dryUY", function(module, exports) {
var $9c98e1f90baefdc8$var$switchFieldsInputs = document.querySelectorAll(".f-switch__input");
$9c98e1f90baefdc8$var$switchFieldsInputs.forEach(function(switchFieldInput) {
    var _a, _b;
    var targets = document.querySelectorAll((_a = switchFieldInput.dataset) === null || _a === void 0 ? void 0 : _a.switchTarget);
    var className = (_b = switchFieldInput.dataset) === null || _b === void 0 ? void 0 : _b.switchTargetClassName;
    switchFieldInput.addEventListener("change", function() {
        addClassOnCheck(switchFieldInput);
    });
    var addClassOnCheck = function(input) {
        if (input === null || input === void 0 ? void 0 : input.checked) targets.forEach(function(target) {
            target.classList.add(className);
        });
        else targets.forEach(function(target) {
            target.classList.remove(className);
        });
    };
    addClassOnCheck(switchFieldInput);
});

});


})();
//# sourceMappingURL=main.050910bd.js.map
